import React from 'react'
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
    SideBtnWrap,
    SidebarRoute
} from './sidebarElements'

const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon/>
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to='about' exact="true" offset={-80} onClick={toggle}>About Us</SidebarLink>
                    <SidebarLink to='services' exact="true" offset={-80} onClick={toggle}>Our Services</SidebarLink>
                    <SidebarLink to='partners' exact="true" offset={-80} onClick={toggle}>Partners</SidebarLink>
                    <SidebarLink to='portfolio' exact="true" offset={-80} onClick={toggle}>Portfolio</SidebarLink>
                    <SidebarLink to='contact' exact="true" offset={-80} onClick={toggle}>Contact Us</SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar